import { render } from "./PoolTable.vue?vue&type=template&id=36eb64ee&scoped=true&ts=true"
import script from "./PoolTable.vue?vue&type=script&lang=ts"
export * from "./PoolTable.vue?vue&type=script&lang=ts"

import "./PoolTable.vue?vue&type=style&index=0&id=36eb64ee&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eb64ee"]])

export default __exports__